import { useEffect } from "react";
import { loginRequest } from "../msalConfig";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

function Login() {
    const { instance } = useMsal();
    const navigate = useNavigate();

    useEffect(() => {
        console.log("msal instance:", instance)

        instance.handleRedirectPromise().then((response) => {
            console.log("response:", response)

            if (response && response.account) {
                console.log("active account")
                instance.setActiveAccount(response.account);
                console.log("account set")
                navigate("/create-project");
            } else {
                console.log("no account")
                instance.loginRedirect({
                    scopes: loginRequest.scopes,
                }).catch((e) => console.error("Login error:", e));
            }
        }).catch((e) => console.error("Login redirect error:", e));
    }, [instance, navigate]);

    return null;
}

export default Login;
